import { changelog } from '@/mocks/home';

export default function ChangelogSection() {
  return (
    <section id="changelog" className="w-full bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-5xl px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="text-xs md:text-sm font-semibold uppercase tracking-widest text-accent-600">
            Changelog
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            更新记录
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
            入口与下载信息会随时间变化，这里记录了每一次内容复核与调整，方便你判断信息的时效。
          </p>
        </div>

        <ol className="mt-10 relative border-l border-background-300 pl-6 md:pl-8">
          {changelog.map((item) => (
            <li key={item.date} className="relative pb-8 last:pb-0">
              <span className="absolute -left-[31px] md:-left-[39px] top-1.5 flex h-4 w-4 items-center justify-center rounded-full border-2 border-accent-500 bg-background-50"></span>
              <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
                <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                  <span className="font-heading text-sm md:text-base font-bold text-foreground-950">
                    {item.version}
                  </span>
                  <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-800">
                    {item.date}
                  </span>
                </div>
                <p className="mt-2 text-sm md:text-base leading-relaxed text-foreground-700">
                  {item.content}
                </p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}